import { IGroupCorrectionGroupSpace, IGroupCorrectionItemWithGroupSpace } from "./IGroupCorrectionItem";
import { EntityTypes } from "../../EntityTypes";
import { SkillLevelValidationStatus } from "../../skill-levels/types/ISkillLevelValidationStatus";
import { ISkillComputed } from "../../skills/types/ISkillComputed";
import { ITimestampable, IHydraResource } from "../../types";
import { IUserResource } from "../../users";

export type IGroupCorrectedSkillLevel = {
    "@id": string;
    "@type": EntityTypes.GROUP_CORRECTED_SKILL_LEVEL;
    skillLevel: string;
    status: SkillLevelValidationStatus;
};

export interface IGroupCorrectionResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.GROUP_CORRECTION;
    groupSpace: string;
    comment: string;
    learner: IUserResource;
    trainer: IUserResource;
    groupCorrectedSkillLevels: IGroupCorrectedSkillLevel[];
}

export interface IGroupCorrectionItemSkillMapping {
    "@id": string;
    "@type": string;
    level: number;
    skill: Omit<ISkillComputed, "rank">;
}

export interface IGroupCorrectionItemCustomMapping extends Omit<
    IGroupCorrectionItemWithGroupSpace,
    "groupCorrectedSkillLevels"
> {
    validatedSkillLevels: IGroupCorrectionItemSkillMapping[];
    unvalidatedSkillLevels: IGroupCorrectionItemSkillMapping[];
    topic: IGroupCorrectionGroupSpace;
}

export const isGroupCorrectionResource = (resource: IHydraResource): resource is IGroupCorrectionResource => {
    return resource["@type"] === EntityTypes.GROUP_CORRECTION;
};
